import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1ChipTheme: Components<Theme>['MuiChip'] = {
    defaultProps: {
        size: 'small',
        variant: 'filled',
    },
    styleOverrides: {
        root: ({ theme, ownerState }) => theme.unstable_sx({
            lineHeight: 1.5, // better v-centering of text within the chip
            transition: 'none',
            borderRadius: 1,

            ...(ownerState.size === 'small' ? {
                height: '22px',
                fontSize: '0.8125rem',
            } : {
                height: '30px',
                fontSize: '14px',
            }),

            // Allow auto height for chips inside autocomplete (they have custom label content)
            '&.MuiAutocomplete-tag': {
                height: 'auto',
            },
        }),
        filled: ({ theme, ownerState }) => theme.unstable_sx({
            ...(ownerState.color === 'default' ? {
                color: 'grey.600',
                borderWidth: '1px',
                borderColor: 'border.emphasis',
                borderStyle: 'solid',
                backgroundColor: 'common.white',
            } : {
                backgroundColor: `${ownerState.color || 'info'}.extraLight`,
                color: `${ownerState.color || 'info'}.extraDark`,
            }),
            // Focus styles for keyboard navigation (e.g., arrow keys in autocomplete chips)
            '&:focus, &:focus-visible': {
                outlineOffset: '2px',
                outlineWidth: '2px',
                outlineStyle: 'solid',
                ...(ownerState.color === 'default' ? {
                    backgroundColor: 'primary.extraLight',
                    borderColor: 'primary.light',
                    outlineColor: theme.palette.primary.light,
                    color: 'primary.extraDark',
                } : {
                    backgroundColor: `${ownerState.color || 'info'}.extraLight`,
                    color: `${ownerState.color || 'info'}.extraDark`,
                    outlineColor: theme.palette[ownerState.color || 'info'].main,
                }),
            },
        }),
        labelSmall: {
            fontWeight: 450,
        },
        iconSmall: {
            fontSize: '14px',
        },
        deleteIcon: ({ theme, ownerState }) => theme.unstable_sx({
            ...(ownerState.color === 'default' ? {
                color: 'info.light',

                '&:hover': {
                    color: 'info.main',
                },
            } : {
                color: `${ownerState.color || 'info'}.light`,

                '&:hover': {
                    color: `${ownerState.color || 'info'}.main`,
                },
            }),
        }),
        clickable: ({ theme, ownerState }) => theme.unstable_sx({
            '&:focus': {
                outlineOffset: '2px',
                outlineWidth: '1px',
                outlineStyle: 'solid',

                ...(ownerState.color === 'default' ? {
                    backgroundColor: 'primary.extraLight',
                    borderColor: 'primary.light',
                    outlineColor: theme.palette.primary.light,
                    color: 'primary.extraDark',
                } : {
                    outlineColor: theme.palette[ownerState.color || 'info'].light,
                    backgroundColor: `${ownerState.color || 'info'}.extraLight`,
                }),
            },
            '&:hover': {
                boxShadow: 'none',

                ...(ownerState.color === 'default' ? {
                    backgroundColor: 'primary.extraLight',
                    borderColor: 'primary.main',
                    color: 'primary.extraDark',
                } : {
                    backgroundColor: `${ownerState.color || 'info'}.extraLight`,
                    borderColor: `${ownerState.color || 'info'}.main`,
                }),
            },
            '&:active': {
                boxShadow: 'none',

                ...(ownerState.color === 'default' ? {
                    backgroundColor: `${theme.palette.primary.extraLight}77`,
                    borderColor: 'primary.main',
                    color: 'primary.extraDark',
                } : {
                    backgroundColor: `${theme.palette[ownerState.color || 'info'].extraLight}77`,
                }),
            },
        }),
    },
}
